<!-- FUNCTIONALITY FOR ALLOWING USER TO TAKE A PICTURE WITH THEIR DEVICE -->
<div id="imgViewerWrapper" [class.showing]="selectedImg">
    <img #img class="img" />
</div>

<ng-container *ngIf="!mobileOrTablet && !invalidSignatures">
    <div *ngIf="pdfIsReadyShowButtons && !hideButtons" class="pdf-buttons">
        <!-- save disabled when not signing and is system document -->
        <div [matTooltip]="tempDisableType6Text()" [matTooltipDisabled]="tempShouldDisableMatTooltip()">
            <button
                style="margin-right: 1rem"
                mat-button
                type="button"
                [ngClass]="isDocumentReadyForSigning && !alreadySignedSession ? 'save-btn' : 'disabled'"
                [class.disabled]="template === 'view'"
                [disabled]="template === 'view' || !isDocumentReadyForSigning || alreadySignedSession || errorState"
                (click)="save()"
            >
                Save
            </button>
        </div>
        <ng-container *ngIf="template !== 'upload' && DocumentStatus.Deleted !== document.documentStatusId">
            <button class="secondary" mat-button type="button" (click)="download()">Download</button>
        </ng-container>
        <ng-container *ngIf="deal?.statusId !== DealStatuses.Archived && template !== 'upload'">
            <button class="secondary" mat-button type="button" (click)="print()">Print</button>
        </ng-container>
        <button class="secondary" mat-button type="button" (click)="emitEvent('cancel')">Cancel</button>
    </div>
</ng-container>

<!-- PDF Viewer -->
<div
    id="pdfViewerWrapper"
    [class.showing]="selectedPdf"
    [class.hidden]="invalidSignatures"
    [ngClass]="mobileOrTablet ? 'pdfViewerWrapper-mobile-tablet' : 'pdfViewerWrapper-desktop'"
>
    <div #pdfViewer class="pdfViewer"></div>

    <!-- PDF ACTION FLOATING BUTTONS FOR MOBILE/TABLET -->
    <ng-container *ngIf="mobileOrTablet && pdfIsReadyShowButtons">
        <div id="file-actions" style="margin-top: 10px; position: absolute; z-index: 1005">
            <div *ngIf="pdfIsReadyShowButtons && !hideButtons && isDocumentReadyForSigning && !alreadySignedSession" class="pdf-buttons mobile-buttons">
                <!-- save disabled when not signing and is system document -->
                <button
                    style="min-width: 100px; height: 36px"
                    mat-button
                    type="button"
                    style="margin-right: 1rem"
                    class="save-btn"
                    [class.disabled]="template === 'view'"
                    [disabled]="template === 'view' || errorState"
                    (click)="save()"
                >
                    Save and Continue
                </button>
                <button style="min-width: 100px; height: 36px" class="secondary" mat-button type="button" (click)="emitEvent('cancel')">Cancel</button>
            </div>
        </div>
    </ng-container>

    <div *ngIf="allowGuidedSigning && pdfIsReadyShowButtons && isDocumentReadyForSigning && !alreadySignedSession" class="signing-actions">
        <button style="margin-left: 1rem" mat-flat-button type="button" id="signing-flow-btn" (click)="guidedSigning()">
            {{ signingSaveAndContinue ? 'Save and Continue' : (guidedSigningOn$ | async) ? 'Next Field' : 'Start Signing' }}
        </button>
    </div>

    <!-- PDF VIEW CHANGE BUTTONS  -->
    <div id="pdf-actions" *ngIf="pdfIsReadyShowButtons">
        <div id="zoom-mini-actions">
            <a *ngIf="allowPdfEdit" class="edit-pdf" matTooltip="Edit PDF" aria-label="Edit PDF" (click)="openEditPdfView()"> Edit </a>
            <a matTooltip="Zoom to 100%" aria-label="Zoom to 100%" [class.bold]="fitMode === fitModes.Zoom" (click)="setPdfDisplayMode(fitModes.Zoom)">
                100%
            </a>
            <a matTooltip="Rotate PDF" (click)="rotatePDF()" class="mini-action"
                ><span style="margin-bottom: -2px" class="material-icons"> rotate_right </span></a
            >
            <a *ngIf="allowPdfTronDownload" class="mini-action" matTooltip="Download PDF" aria-label="Download PDF" (click)="downloadFromPdfTron()">
                <span class="material-icons">download</span>
            </a>
            <a matTooltip="Fit PDF to Height" aria-label="Fit PDF to Height" (click)="setPdfDisplayMode(fitModes.FitPage)">
                <span [class.bold]="fitMode === fitModes.FitPage" class="material-icons">height</span>
            </a>
            <a matTooltip="Fit PDF to Width" aria-label="Fit PDF to Width" (click)="setPdfDisplayMode(fitModes.FitWidth)">
                <span [class.bold]="fitMode === fitModes.FitWidth" class="material-icons width"> height </span>
            </a>
        </div>
    </div>
</div>

<ng-container *ngIf="!invalidSignatures">
    <ddj-spinner *ngIf="isLoading && template === 'view' && document?.documentStatusId === DocumentStatus.Deleted"></ddj-spinner>
    <ddj-pdf-spinner *ngIf="isLoading && template !== 'upload' && document?.documentStatusId !== DocumentStatus.Deleted"></ddj-pdf-spinner>
    <upload-image-spinner *ngIf="isLoading && template === 'upload'"></upload-image-spinner>
</ng-container>
